import { render, staticRenderFns } from "./AdditionalFieldsForm.vue?vue&type=template&id=607659da"
import script from "./AdditionalFieldsForm.vue?vue&type=script&lang=js"
export * from "./AdditionalFieldsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports